import React from 'react';
import { BookOpenIcon, FolderOpenIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: FolderOpenIcon,
  label: '+300 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and wine professionals'
}];
export function SocialProof() {
  return <section className="border-b border-line bg-panel py-5" aria-label="What the Teacher Ready includes" data-id="element-215" data-mp="3elciyvc7z49">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-muted sm:justify-between" data-id="element-216" data-mp="8e7svh6gpvha">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-217" data-mp="3ushfbkqu0tff">
            <Icon className="h-5 w-5 text-sage" aria-hidden="true" data-id="element-218" data-mp="md7f6i6i5yaa" /> {label}
          </span>)}
      </div>
    </section>;
}